import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api/src/common/queryFunction';

import type { ImportERPWorkData, ImportERPWorkQueryVars } from './types';
import { getImportERPWorkQueryKey } from './util';

export const useImportERPWork: MutationFunction<
  ImportERPWorkData,
  ImportERPWorkQueryVars
> = ({ query, requestOptions, queryOptions } = {}) => {
  const urlPath = '/erp_stores/import_from_erp';

  const request = useRequest(requestOptions);

  const mutationKey = getImportERPWorkQueryKey();

  return useMutation(
    (requestData) => {
      return request(urlPath, {
        query,
        init: {
          method: 'POST',
          body: { ...requestData },
        },
      });
    },
    {
      ...queryOptions,
      mutationKey,
    },
  );
};
